var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMobileMenuWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2736_12841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 5.25H21.75C22.125 5.25 22.5 4.92188 22.5 4.54688C22.5 4.17188 22.125 3.75 21.75 3.75H2.25C1.82812 3.75 1.5 4.125 1.5 4.5C1.5 4.875 1.82812 5.25 2.25 5.25ZM21.75 11.25H2.25C1.82812 11.25 1.5 11.625 1.5 12C1.5 12.4219 1.82812 12.75 2.25 12.75H21.75C22.125 12.75 22.5 12.4219 22.5 12C22.5 11.625 22.125 11.25 21.75 11.25ZM21.75 18.75H2.25C1.82812 18.75 1.5 19.125 1.5 19.5C1.5 19.875 1.82812 20.25 2.25 20.25H21.75C22.125 20.25 22.5 19.9219 22.5 19.5469C22.5 19.1719 22.125 18.75 21.75 18.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2736_12841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobileMenuWhite);
export default __webpack_public_path__ + "static/media/Icon_MobileMenu_White.dd05aee795fcd0c85cf05f4b5c737919.svg";
export { ForwardRef as ReactComponent };